import { OperationParameter, OperationURLParameter } from "@azure/core-client";
import {
  CreateCustomerRequest as CreateCustomerRequestMapper,
  UpdateCustomerRequest as UpdateCustomerRequestMapper,
  MobileAppVerifyRequest as MobileAppVerifyRequestMapper,
  ApplicantSwiftcardsRequest as ApplicantSwiftcardsRequestMapper
} from "../models/mappers";

export const contentType: OperationParameter = {
  parameterPath: ["options", "contentType"],
  mapper: {
    defaultValue: "application/json",
    isConstant: true,
    serializedName: "Content-Type",
    type: {
      name: "String"
    }
  }
};

export const body: OperationParameter = {
  parameterPath: ["options", "body"],
  mapper: CreateCustomerRequestMapper
};

export const accept: OperationParameter = {
  parameterPath: "accept",
  mapper: {
    defaultValue: "application/json",
    isConstant: true,
    serializedName: "Accept",
    type: {
      name: "String"
    }
  }
};

export const $host: OperationURLParameter = {
  parameterPath: "$host",
  mapper: {
    serializedName: "$host",
    required: true,
    type: {
      name: "String"
    }
  },
  skipEncoding: true
};

export const openIDToken: OperationParameter = {
  parameterPath: "openIDToken",
  mapper: {
    serializedName: "openIDToken",
    required: true,
    type: {
      name: "String"
    }
  }
};

export const body1: OperationParameter = {
  parameterPath: ["options", "body"],
  mapper: UpdateCustomerRequestMapper
};

export const id: OperationURLParameter = {
  parameterPath: "id",
  mapper: {
    serializedName: "id",
    required: true,
    type: {
      name: "String"
    }
  }
};

export const contentType1: OperationParameter = {
  parameterPath: ["options", "contentType"],
  mapper: {
    serializedName: "Content-Type",
    type: {
      name: "Enum",
      allowedValues: ["image/jpeg", "image/png"]
    }
  }
};

export const data: OperationParameter = {
  parameterPath: ["options", "data"],
  mapper: {
    serializedName: "data",
    type: {
      name: "Stream"
    }
  }
};

export const accept1: OperationParameter = {
  parameterPath: "accept",
  mapper: {
    defaultValue: "application/json",
    isConstant: true,
    serializedName: "Accept",
    type: {
      name: "String"
    }
  }
};

export const accept2: OperationParameter = {
  parameterPath: "accept",
  mapper: {
    defaultValue: "image/png, image/jpeg, application/json",
    isConstant: true,
    serializedName: "Accept",
    type: {
      name: "String"
    }
  }
};

export const body2: OperationParameter = {
  parameterPath: ["options", "body"],
  mapper: MobileAppVerifyRequestMapper
};

export const swiftCardNumber: OperationParameter = {
  parameterPath: "swiftCardNumber",
  mapper: {
    serializedName: "swiftCardNumber",
    required: true,
    type: {
      name: "String"
    }
  }
};

export const billingCustomerEmail: OperationParameter = {
  parameterPath: "billingCustomerEmail",
  mapper: {
    serializedName: "billingCustomerEmail",
    required: true,
    type: {
      name: "String"
    }
  }
};

export const body3: OperationParameter = {
  parameterPath: ["options", "body"],
  mapper: ApplicantSwiftcardsRequestMapper
};
